import { Download } from "lucide-react";

import { Button } from "../../../button";
import { DetectedFile } from "../../types";

interface ImagePreviewProps {
  dataUrl: string;
  detectedFile: DetectedFile;
}

export const ImagePreview = ({ dataUrl, detectedFile }: ImagePreviewProps) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `image.${detectedFile.extension || "png"}`;
    link.click();
  };

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-medium">Image Preview</div>
        <div className="flex gap-2">
          <Button variant="outline" size="tinyIcon" onClick={handleDownload}>
            <Download className="h-3 w-3" />
          </Button>
        </div>
      </div>
      <img
        src={dataUrl}
        alt="file preview"
        className="max-h-[400px] w-full rounded object-contain"
        style={{ maxWidth: "480px" }}
      />
    </div>
  );
};
